import { render } from "./MatchDetails.vue?vue&type=template&id=38fb1fa1"
import script from "./MatchDetails.vue?vue&type=script&lang=ts"
export * from "./MatchDetails.vue?vue&type=script&lang=ts"
script.render = render

export default script